import * as React from 'react';

import { Row, Col, Typography, Empty } from 'antd';
import CommonTypeProps from '../../common/CommonTypeProps';
import DashboardPageLayoutV2 from '../../layout/dashboard/DashboardPageLayoutV2';

interface UI403Props extends CommonTypeProps {}

export class UI403Component extends React.Component<UI403Props, any> {
  formRef: any;

  state = {};

  componentDidMount = () => {};

  renderContentLayout = (version?: string) => {
    return (
      <Row type='flex' justify='space-between' gutter={10}>
        {!version ||
          (version === 'v1' && (
            <Col xs={24}>
              <Typography.Title className='o2o-title-grey'>403 Forbidden</Typography.Title>
            </Col>
          ))}

        <Col xs={24}>
          <Empty
            imageStyle={{
              height: 100,
              margin: 25,
            }}
            description={
              <div>
                <Typography.Text>
                  Sorry, you're not allowed in here.
                  <br /> Please contact IT
                </Typography.Text>
              </div>
            }
          ></Empty>
        </Col>
      </Row>
    );
  };

  render() {
    return (
      <DashboardPageLayoutV2
        props={this.props}
        pageTitle='403 Forbidden'
        renderContentLayout={this.renderContentLayout}
        metaTitle='403'
      />
    );
  }
}
